module.exports = __webpack_public_path__ + "img/orbit-realistic-icon.be570dcc.png";